export const GET_ALL_INTERFACES = 'GET_ALL_INTERFACES';


